import React, { Component } from 'react'
import { connect } from 'react-redux'

class ListarCamionesCalados extends Component {
  render () {
    // const { camsCalados } = this.props
    // const camsCaladosPorPuesto = camsCalados.filter((camion) => camion.puestoDeCalado === nombrePuestoCalado)

    // console.log('y tambien tengo los camiones', camsCalados)
    // console.log('mm', camsCaladosPorPuesto)

    return (
      <div>
        <h3>Listado de los últimos camiones calados</h3>

      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    camsCalados: state.calado.camsCalados,
    nombrePuestoCalado: state.calado.nombrePuestoCalado
  }
}
export default connect(mapStateToProps)(ListarCamionesCalados)
